import React from "react";
import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
} from "reactstrap";
import AuthFooter from "components/Footers/AuthFooter.js";
import logo from "../../assets/img/logo1.jpg";

import client1 from "../../assets/img/new-clients/client1.jpeg";
import client2 from "../../assets/img/new-clients/client2.jpeg";
import client3 from "../../assets/img/new-clients/client3.jpeg";
import client4 from "../../assets/img/new-clients/client4.png";
import client5 from "../../assets/img/new-clients/client5.jpeg";
import client6 from "../../assets/img/new-clients/client6.jpeg";
import client7 from "../../assets/img/new-clients/client7.jpg";
import client8 from "../../assets/img/new-clients/client8.jpeg";
import client9 from "../../assets/img/new-clients/client9.jpeg";
import client10 from "../../assets/img/new-clients/client10.jpeg";
import client11 from "../../assets/img/new-clients/client11.jpeg";
import client12 from "../../assets/img/new-clients/client12.jpeg";
import client13 from "../../assets/img/new-clients/client13.jpeg";
import client14 from "../../assets/img/new-clients/client14.jpeg";
import client15 from "../../assets/img/new-clients/client15.jpeg";
import client16 from "../../assets/img/new-clients/client16.jpeg";
import client17 from "../../assets/img/new-clients/client17.png";
import client18 from "../../assets/img/new-clients/client18.jpg";

const clientLogos = [
  { id: 1, logo: client1 },
  { id: 2, logo: client2 },
  { id: 3, logo: client3 },
  { id: 4, logo: client4 },
  { id: 5, logo: client5 },
  { id: 6, logo: client6 },
  { id: 7, logo: client7 },
  { id: 8, logo: client8 },
  { id: 9, logo: client9 },
  { id: 10, logo: client10 },
  { id: 11, logo: client11 },
  { id: 12, logo: client12 },
  { id: 13, logo: client13 },
  { id: 14, logo: client14 },
  { id: 15, logo: client15 },
  { id: 16, logo: client16 },
  { id: 17, logo: client17 },
  { id: 18, logo: client18 },
];

export default function OurClients() {
  const [navbarColor] = React.useState("info");
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  const handleAppClick = () => {
    if (collapseOpen === true) {
      document.documentElement.classList.toggle("nav-open");
      setCollapseOpen(false);
    }
  };

  return (
    <div>
      <div id="app">
        <h1 className="sr-only">Our Clients</h1>

        {/* Navbar */}
        <Navbar
          className={"fixed-top " + navbarColor}
          expand="lg"
          style={{ marginTop: 0 }}
        >
          <Container>
            <div className="navbar-translate">
              <NavbarBrand href="/" data-placement="bottom">
                <div className="d-flex">
                  <img
                    alt="Course App"
                    src={logo}
                    style={{
                      height: "40px",
                      width: "auto",
                      borderRadius: "4px",
                      marginRight: "5px",
                    }}
                  />
                  <h3
                    style={{
                      fontWeight: 600,
                      textDecoration: "none",
                      textTransform: "capitalize",
                      fontSize: "22px",
                    }}
                  >
                    GSR TRAINING CONSULTING
                  </h3>
                </div>
              </NavbarBrand>
            </div>
            <div
              className="phone-view-hide"
              style={{ marginRight: "20px" }}
              onClick={() => {
                document.documentElement.classList.toggle("nav-open");
                setCollapseOpen(true);
              }}
              aria-expanded={collapseOpen}
            >
              <i className="fa fa-bars" style={{ color: "white" }} />
            </div>
            <Collapse
              className="justify-content-end"
              isOpen={collapseOpen}
              navbar
            >
              <Nav navbar>
                <NavItem>
                  <NavLink tag="a" href="/" className="mr-3">
                    HOME
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink tag="a" href="/our-clients" className="mr-3">
                    OUR CLIENTS
                  </NavLink>
                </NavItem>
                <NavItem>
                  <NavLink
                    className="mt--2"
                    href="/overseas-training-calendar"
                    style={{
                      fontWeight: "700",
                      color: "yellow",
                      backgroundColor: "#17d0cf",
                      padding: "10px",
                      borderRadius: "10px",
                    }}
                  >
                    TRAINING CALENDAR
                  </NavLink>
                </NavItem>
              </Nav>
            </Collapse>
          </Container>
        </Navbar>

        <div onClick={() => handleAppClick()}>
          {/* Hero Section */}
          <div className="clients-hero" style={{ marginTop: "70px" }}>
            <div className="clients-hero-overlay" />
            <div className="clients-hero-content">
              <Container>
                <h1>Our Clients</h1>
                <p>
                  Proud to have partnered with leading organizations across sectors
                </p>
                <div className="clients-stat-block">
                  <div>
                    <div className="clients-stat-number">
                      {clientLogos.length}+
                    </div>
                    <div className="clients-stat-label">Organizations Served</div>
                  </div>
                  <div className="clients-stat-divider" />
                  <div>
                    <div className="clients-stat-number">10+</div>
                    <div className="clients-stat-label">Years Experience</div>
                  </div>
                  <div className="clients-stat-divider" />
                  <div>
                    <div className="clients-stat-number">4+</div>
                    <div className="clients-stat-label">Sectors Covered</div>
                  </div>
                </div>
              </Container>
            </div>
          </div>

          {/* Clients Grid */}
          <section style={{ padding: "70px 0 90px" }}>
            <Container>
              <h4 className="head-subtitle">Our Partners</h4>
              <h2
                className="big-text"
                style={{ marginLeft: 0, marginBottom: "40px" }}
              >
                Trusted by <strong>Leading Organizations</strong>
              </h2>
              <div className="clients-grid">
                {clientLogos.map((client) => (
                  <div key={client.id} className="client-card">
                    <img
                      src={client.logo}
                      alt={`Client ${client.id}`}
                      loading="lazy"
                    />
                  </div>
                ))}
              </div>
            </Container>
          </section>

          {/* Call to Action */}
          <div className="clients-cta">
            <Container>
              <h2>Ready to Partner with Us?</h2>
              <p>
                Let's discuss how GSR Training Consulting can help transform your
                organization through strategic leadership training and consulting.
              </p>
              <div>
                <a href="/#contact-us" className="clients-cta-btn clients-cta-btn-primary">
                  <i className="fas fa-envelope" />
                  Get in Touch
                </a>
                <a
                  href="tel:+233265084067"
                  className="clients-cta-btn clients-cta-btn-outline"
                >
                  <i className="fas fa-phone" />
                  Call Now
                </a>
              </div>
            </Container>
          </div>

          <AuthFooter />
        </div>
      </div>
    </div>
  );
}
